export default "__VITE_PUBLIC_ASSET__644ffb8d__"